import LinkedInLogo from "../assets/linkedin-icon.svg";
import GitHubLogo from "../assets/GitHub_logo.svg";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-item">
        <a
          href="https://www.linkedin.com/in/yaman-sanobar/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={LinkedInLogo} alt="Twitter Logo" />
        </a>
      </div>
      <div className="footer-item">
        <a
          href="https://github.com/snoberyman"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={GitHubLogo} alt="Twitter Logo" />
        </a>
      </div>
      <div className="footer-item"></div>
      <div className="footer-item"></div>
    </footer>
  );
}

export default Footer;
